import React from 'react'

import styles from './styles.module.css'

export function Container({ children }: { children: React.ReactNode }) {
  return (
    <div className={styles.content}>
      <div className="flex flex-col items-center p-6 gap-2">{children}</div>
    </div>
  )
}
